import { useMemo } from 'react';
import { formatDate, formatTime } from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';
import { isSameDay, isToday, isTomorrow } from 'date-fns';
import type { FormatWeekdayType } from './format-weekday';
import { formatWeekday } from './format-weekday';
import { getRelativeDay } from './get-relative-day';

export function useDatetimeFormat() {
  const { language } = useSettings();
  const locale = language?.language ?? 'en';

  return useMemo(() => {
    return {
      getToday: () => getRelativeDay(0, locale),
      formatWeekday: (date: Date, type: FormatWeekdayType) =>
        formatWeekday(date, type, locale),
      formatDate: (date: Date) =>
        formatDate({
          date,
          locale
        }),
      formatTime: (date: Date) => formatTime({ date, locale }),
      formatInterval: (dateA: Date, dateB: Date) => {
        let finalStr = '';

        const formatDatePart = (date: Date) => {
          let str = '';

          if (isToday(date)) {
            str += `${getRelativeDay(0, locale)}, `;
          }
          if (isTomorrow(date)) {
            str += `${getRelativeDay(1, locale)}, `;
          }

          str += `${formatDate({ date, locale })}, `;

          return str;
        };

        finalStr += `${formatDatePart(dateA)}`;
        finalStr += `${formatTime({ date: dateA, locale })} - `;

        if (!isSameDay(dateA, dateB)) {
          finalStr += `${formatDatePart(dateB)}`;
        }
        finalStr += `${formatTime({ date: dateB, locale })}`;

        return finalStr;
      }
    };
  }, [locale]);
}
